/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAvailableReportTypes } from '../fn/reports/get-available-report-types';
import { GetAvailableReportTypes$Params } from '../fn/reports/get-available-report-types';
import { getReport } from '../fn/reports/get-report';
import { GetReport$Params } from '../fn/reports/get-report';


/**
 * Reporting endpoints. All operations require EASYLOT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class ReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAvailableReportTypes()` */
  static readonly GetAvailableReportTypesPath = '/reports';

  /**
   * The list of available report types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableReportTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableReportTypes$Response(params?: GetAvailableReportTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'MERCHANTS_WITH_DELIVERY_METHODS' | 'PURCHASE_IN_LAST_30_DAYS' | 'PUBLISHED_PRODUCTS' | 'TENDERS' | 'DISCOUNTS'>>> {
    const obs = getAvailableReportTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * The list of available report types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailableReportTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableReportTypes(params?: GetAvailableReportTypes$Params, context?: HttpContext): Observable<Array<'MERCHANTS_WITH_DELIVERY_METHODS' | 'PURCHASE_IN_LAST_30_DAYS' | 'PUBLISHED_PRODUCTS' | 'TENDERS' | 'DISCOUNTS'>> {
    const resp = this.getAvailableReportTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<'MERCHANTS_WITH_DELIVERY_METHODS' | 'PURCHASE_IN_LAST_30_DAYS' | 'PUBLISHED_PRODUCTS' | 'TENDERS' | 'DISCOUNTS'>>): Array<'MERCHANTS_WITH_DELIVERY_METHODS' | 'PURCHASE_IN_LAST_30_DAYS' | 'PUBLISHED_PRODUCTS' | 'TENDERS' | 'DISCOUNTS'> => r.body)
    );
  }

  /** Path part for operation `getReport()` */
  static readonly GetReportPath = '/reports/{type}';

  /**
   * Get the specific resource in CSV.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReport$Response(params: GetReport$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getReport(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the specific resource in CSV.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReport(params: GetReport$Params, context?: HttpContext): Observable<string> {
    const resp = this.getReport$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
